package com.cs.ejobin.ui.components

import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import com.cs.ejobin.i18n.t

@Composable
fun ErrorText(errorKey: String?) {
    if (errorKey.isNullOrBlank()) return
    Text(t(errorKey), color = MaterialTheme.colorScheme.error)
}